import { useRouter } from 'next/router';
import { FunctionalComponent } from 'interfaces/components';
import Footer from '../Footer';
import Navbar from '../Navbar';
import ConditionalInfoHeader from 'components/ConditionalInfoHeader';
import { IInfoNotice } from 'components/ConditionalInfoHeader/ConditionalInfoHeader';
import CustomHead from 'containers/CustomHead';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'next-i18next/pages';

// The notice in the yellow bar above the home page navigation. null hides the
// bar. To show one, set translation keys (and an optional link) here, e.g.
//   { title: 'Travel updates', message: 'New routes from Budapest', href: '/posts/' }
// and add both keys to public/locales/{en,hu}/translation.json and to
// scripts/i18n/dynamic-keys.json (WHIT-409).
const HOME_NOTICE: IInfoNotice | null = null;

interface Props extends FunctionalComponent {
  divClassName?: string;
  navBarClassName?: string;
  verticalDotsClassName?: string;
  isResultsPage?: boolean;
  titleProduction?: string;
  titleStaging?: string;
  metaDescriptionProd?: string;
  metaDescriptionStaging?: string;
  canonicalProd?: string;
  canonicalStaging?: string;
}

const Layout: React.FC<Props> = ({ children, ...props }) => {
  const {
    divClassName,
    navBarClassName,
    verticalDotsClassName,
    titleProduction,
    titleStaging,
    metaDescriptionProd,
    metaDescriptionStaging,
    canonicalProd,
    canonicalStaging,
  } = props;
  const router = useRouter();
  const pathname = router.pathname;
  const isHome = pathname === '/';
  const isResults = pathname === '/results';
  const newsLetterRef = useRef<any>(null);
  useEffect(() => {
    // Check if the URL contains #newsletter and if it contains enable the focus on the input
    if (router.asPath.includes('#newsletter')) {
      if (newsLetterRef.current) {
        newsLetterRef.current.focus();
      }
    }
  }, [router.asPath]);

  return (
    <div className={divClassName}>
      <CustomHead
        titleProduction={titleProduction}
        titleStaging={titleStaging}
        metaDescriptionProd={metaDescriptionProd}
        metaDescriptionStaging={metaDescriptionStaging}
        canonicalProd={canonicalProd}
        canonicalStaging={canonicalStaging}
      />
      {isHome && (
        <ConditionalInfoHeader
          newsLetterRef={newsLetterRef}
          notice={HOME_NOTICE}
        />
      )}
      <Navbar
        isHome={isHome}
        navBarClassName={navBarClassName}
        verticalDotsClassName={verticalDotsClassName}
        isResultsPage={isResults}
      />
      {/* The page's main landmark. Pages that make this wrapper a flex column
          or give it a height rely on their content being its direct child,
          so there the landmark must not add a box of its own. */}
      <main className={divClassName ? 'contents' : undefined}>{children}</main>
      {!isResults && <Footer newsLetterRef={newsLetterRef} />}
    </div>
  );
};

export default Layout;
